/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import Restricted from 'src/app/permissions/restricted';
import { useAppSelector } from 'src/services/redux/app/store';
import { KTSVG } from '../../../helpers';
import { AsideMenuItem } from './AsideMenuItem';
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub';

export function AsideMenuMain() {
  const intl = useIntl();
  const { user } = useAppSelector((state: any) => state.auth);
  const [isReservationOpen, setIsReservationOpen] = useState(true);
  const [isRoomManagementOpen, setIsRoomManagementOpen] = useState(true);
  const [isGuestManagementOpen, setIsGuestManagementOpen] = useState(true);
  const [isFinanceOpen, setIsFinanceOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  return (
    <>
      <Restricted to="ROLE_DASHBOARD">
        <AsideMenuItem
          to="/dashboard"
          icon="/media/icons/duotone/Design/PenAndRuller.svg"
          // title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          title="Gösterge Paneli"
          fontIcon="bi-app-indicator"
        />
      </Restricted>

      <div className="menu-item">
        <div className="menu-content pt-8 pb-2" style={{ cursor: 'pointer' }} onClick={() => setIsReservationOpen(!isReservationOpen)}>
          <span className="menu-section text-muted text-uppercase fs-8 ls-1 d-flex align-items-center">
            <i className={`bi ${isReservationOpen ? 'bi-chevron-down' : 'bi-chevron-right'} me-2 fs-9`}></i>
            Rezervasyon Yönetimi
          </span>
        </div>
      </div>

      {isReservationOpen && (
        <>
          <Restricted to="ROLE_RESERVATIONS">
            <AsideMenuItem to="/reservations" icon="/media/icons/duotone/Communication/Archive.svg" title="Rezervasyonlar" fontIcon="bi-app-indicator" />
          </Restricted>

          {/* <Restricted to="ROLE_CHECKIN_CHECKOUT">
            <AsideMenuItem to="/check-in-out" icon="/media/icons/duotone/Shopping/Key.svg" title="Check-In / Check-Out" fontIcon="bi-app-indicator" />
          </Restricted> */}

          <Restricted to="ROLE_ROOM_CALENDAR">
            <AsideMenuItem to="/room-calendar" icon="/media/icons/duotone/Layout/Layout-4-blocks.svg" title="Oda Takvimi" fontIcon="bi-app-indicator" />
          </Restricted>
        </>
      )}

      <div className="menu-item">
        <div className="menu-content pt-8 pb-2" style={{ cursor: 'pointer' }} onClick={() => setIsRoomManagementOpen(!isRoomManagementOpen)}>
          <span className="menu-section text-muted text-uppercase fs-8 ls-1 d-flex align-items-center">
            <i className={`bi ${isRoomManagementOpen ? 'bi-chevron-down' : 'bi-chevron-right'} me-2 fs-9`}></i>
            Oda Yönetimi
          </span>
        </div>
      </div>

      {isRoomManagementOpen && (
        <>
          <Restricted to="ROLE_ROOMS">
            <AsideMenuItem to="/rooms" icon="/media/icons/duotone/Home/Door-open.svg" title="Odalar" fontIcon="bi-app-indicator" />
          </Restricted>

          <Restricted to="ROLE_ROOM_TYPES">
            <AsideMenuItem to="/room-types" icon="/media/icons/duotone/Home/Home.svg" title="Oda Tipleri" fontIcon="bi-app-indicator" />
          </Restricted>

          <Restricted to="ROLE_HOUSEKEEPING">
            <AsideMenuItem to="/housekeeping" icon="/media/icons/duotone/Clothes/Briefcase.svg" title="Kat Hizmetleri" fontIcon="bi-app-indicator" />
          </Restricted>
        </>
      )}

      <div className="menu-item">
        <div className="menu-content pt-8 pb-2" style={{ cursor: 'pointer' }} onClick={() => setIsGuestManagementOpen(!isGuestManagementOpen)}>
          <span className="menu-section text-muted text-uppercase fs-8 ls-1 d-flex align-items-center">
            <i className={`bi ${isGuestManagementOpen ? 'bi-chevron-down' : 'bi-chevron-right'} me-2 fs-9`}></i>
            Misafir Yönetimi
          </span>
        </div>
      </div>

      {isGuestManagementOpen && (
        <>
          <Restricted to="ROLE_GUESTS">
            <AsideMenuItem to="/guests" icon="/media/icons/duotone/Communication/Group.svg" title="Misafirler" fontIcon="bi-app-indicator" />
          </Restricted>

          <Restricted to="ROLE_GUEST_REQUESTS">
            <AsideMenuItem to="/guest-requests" icon="/media/icons/duotone/Communication/Clipboard-list.svg" title="Misafir Talepleri" fontIcon="bi-app-indicator" />
          </Restricted>
        </>
      )}

      <div className="menu-item">
        <div className="menu-content pt-8 pb-2" style={{ cursor: 'pointer' }} onClick={() => setIsFinanceOpen(!isFinanceOpen)}>
          <span className="menu-section text-muted text-uppercase fs-8 ls-1 d-flex align-items-center">
            <i className={`bi ${isFinanceOpen ? 'bi-chevron-down' : 'bi-chevron-right'} me-2 fs-9`}></i>
            Finans & Muhasebe <span className="badge badge-light-warning fs-9 ms-2">Yakında</span>
          </span>
        </div>
      </div>

      {/* Finans & Muhasebe - Pasif (Yakında) */}
      {isFinanceOpen && (
        <>
          <div className="menu-item" style={{ opacity: 0.5, pointerEvents: 'none' }}>
            <span className="menu-link">
              <span className="menu-icon">
                <KTSVG path="/media/icons/duotone/Shopping/Receipt.svg" className="svg-icon-2" />
              </span>
              <span className="menu-title">Faturalar</span>
            </span>
          </div>

          <div className="menu-item" style={{ opacity: 0.5, pointerEvents: 'none' }}>
            <span className="menu-link">
              <span className="menu-icon">
                <KTSVG path="/media/icons/duotone/Shopping/Credit-card.svg" className="svg-icon-2" />
              </span>
              <span className="menu-title">Ödemeler</span>
            </span>
          </div>

          <div className="menu-item" style={{ opacity: 0.5, pointerEvents: 'none' }}>
            <span className="menu-link">
              <span className="menu-icon">
                <KTSVG path="/media/icons/duotone/Shopping/Chart-line-1.svg" className="svg-icon-2" />
              </span>
              <span className="menu-title">Giderler</span>
            </span>
          </div>

          <div className="menu-item" style={{ opacity: 0.5, pointerEvents: 'none' }}>
            <span className="menu-link">
              <span className="menu-icon">
                <KTSVG path="/media/icons/duotone/Files/File-done.svg" className="svg-icon-2" />
              </span>
              <span className="menu-title">Raporlar</span>
            </span>
          </div>
        </>
      )}

      <div className="menu-item">
        <div className="menu-content pt-8 pb-2" style={{ cursor: 'pointer' }} onClick={() => setIsServicesOpen(!isServicesOpen)}>
          <span className="menu-section text-muted text-uppercase fs-8 ls-1 d-flex align-items-center">
            <i className={`bi ${isServicesOpen ? 'bi-chevron-down' : 'bi-chevron-right'} me-2 fs-9`}></i>
            Hizmetler <span className="badge badge-light-warning fs-9 ms-2">Yakında</span>
          </span>
        </div>
      </div>

      {/* Hizmetler - Pasif (Yakında) */}
      {isServicesOpen && (
        <>
          <div className="menu-item" style={{ opacity: 0.5, pointerEvents: 'none' }}>
            <span className="menu-link">
              <span className="menu-icon">
                <KTSVG path="/media/icons/duotone/Cooking/Fork.svg" className="svg-icon-2" />
              </span>
              <span className="menu-title">Restoran</span>
            </span>
          </div>

          <div className="menu-item" style={{ opacity: 0.5, pointerEvents: 'none' }}>
            <span className="menu-link">
              <span className="menu-icon">
                <KTSVG path="/media/icons/duotone/Clothes/Shirt.svg" className="svg-icon-2" />
              </span>
              <span className="menu-title">SPA & Wellness</span>
            </span>
          </div>

          <div className="menu-item" style={{ opacity: 0.5, pointerEvents: 'none' }}>
            <span className="menu-link">
              <span className="menu-icon">
                <KTSVG path="/media/icons/duotone/Clothes/Tie.svg" className="svg-icon-2" />
              </span>
              <span className="menu-title">Çamaşırhane</span>
            </span>
          </div>

          <div className="menu-item" style={{ opacity: 0.5, pointerEvents: 'none' }}>
            <span className="menu-link">
              <span className="menu-icon">
                <KTSVG path="/media/icons/duotone/Shopping/Box3.svg" className="svg-icon-2" />
              </span>
              <span className="menu-title">Minibar</span>
            </span>
          </div>
        </>
      )}

      {/* Sistem Yönetimi - Kaldırıldı (Tesis Ayarları hesap menüsüne taşındı) */}

      {/* <div className="menu-item">
        <div className="menu-content pt-8 pb-2">
          <span className="menu-section text-muted text-uppercase fs-8 ls-1">Üçüncü Parti Sistemler</span>
        </div>
      </div> */}

      <Restricted to="ROLE_CHANNEL_MANAGER">
        <AsideMenuItem to="/channel-manager" icon="/media/icons/duotone/Communication/RSS.svg" title="Kanal Yöneticisi" fontIcon="bi-app-indicator" />
      </Restricted>

      <Restricted to="ROLE_BOOKING_ENGINES">
        <AsideMenuItem to="/booking-engines" icon="/media/icons/duotone/Shopping/Cart1.svg" title="Rezervasyon Motorları" fontIcon="bi-app-indicator" />
      </Restricted>

      <Restricted to="ROLE_PMS_INTEGRATION">
        <AsideMenuItem to="/pms-integration" icon="/media/icons/duotone/Code/Compiling.svg" title="Elektraweb Entegrasyonu" fontIcon="bi-app-indicator" />
      </Restricted>

      <Restricted to="ROLE_SUPER_ADMIN">
        <AsideMenuItem to="/agency-channel" icon="/media/icons/duotone/Communication/Group.svg" title="Acente Kanalı" fontIcon="bi-app-indicator" />
      </Restricted>

      <Restricted to="ROLE_PAYMENT_GATEWAYS">
        <AsideMenuItem to="/payment-gateways" icon="/media/icons/duotone/Shopping/Wallet3.svg" title="Ödeme Sistemleri" fontIcon="bi-app-indicator" />
      </Restricted>

      <Restricted to="ROLE_API_MANAGEMENT">
        <AsideMenuItem to="/api-management" icon="/media/icons/duotone/Code/Question-circle.svg" title="API Yönetimi" fontIcon="bi-app-indicator" />
      </Restricted>

      <div className="menu-item">
        <div className="menu-content"></div>
      </div>
    </>
  );
}
